import { Pipe, PipeTransform } from '@angular/core';
import { MarkdownContentService } from './markdown-content.service';

@Pipe({
  name: 'markdownHtml',
  standalone: true
})
export class MarkdownHtmlPipe implements PipeTransform {
  constructor(private readonly markdownContentService: MarkdownContentService) {}

  transform(value: string | null | undefined): string {
    return this.markdownContentService.renderToHtml(value);
  }
}